@if (compareUi.showCompareToggle()) {
  <div class="d-flex align-items-center buttons me-2">
    <button
      type="button"
      class="d-flex align-items-center justify-content-center btn btn-drive-compare py-2 px-1"
      [class.active]="compareUi.compareActive()"
      [attr.aria-pressed]="compareUi.compareActive()"
      [title]="toggleTitle"
      [attr.aria-label]="toggleTitle"
      (click)="onToggle()">
      <span class="icon-wrapper">
        <svg
          width="16"
          height="16"
          viewBox="0 0 14 14"
          fill="none"
          stroke="currentColor"
          stroke-width="1.4"
          stroke-linecap="round"
          aria-hidden="true"
          class="drive-compare-icon">
          <path d="M7.4 10.7H2.9A2.3 2.3 0 0 1 .6 8.4V5.2A2.3 2.3 0 0 1 2.9 2.9H7.4" />
          <path d="M10.1 2.9H10.5A2.3 2.3 0 0 1 12.8 5.2V8.4A2.3 2.3 0 0 1 10.5 10.7H10.1" />
          <line x1="7.4" y1=".6" x2="7.4" y2="13" />
        </svg>
      </span>
    </button>
  </div>
}
